<template>
  <div class="contacts">
    <CloseModalBtn :closeModal="closeModal" />
    <svg
      class="icon"
      width="53"
      height="57"
      viewBox="0 0 53 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 18.75H15V15H22.5V18.75ZM33.75 22.5H15V26.25H33.75V22.5ZM52.5 20.7V52.5C52.5 54.5625 50.8125 56.25 48.75 56.25H3.75C1.6875 56.25 0 54.5625 0 52.5V20.7C0 19.4625 0.6 18.3375 1.575 17.6625L7.5 13.425V11.25C7.5 9.1875 9.1875 7.5 11.25 7.5H15.75L26.25 0L36.75 7.5H41.25C43.3125 7.5 45 9.1875 45 11.25V13.425L50.925 17.6625C51.9375 18.375 52.5 19.4625 52.5 20.7ZM11.25 28.125L26.25 37.5L41.25 28.125V11.25H11.25V28.125ZM3.75 50.625L20.625 39.375L3.75 28.125V50.625ZM45 52.5L26.25 41.25L7.5 52.5H45ZM48.75 28.125L31.875 39.375L48.75 50.625V28.125Z"
        fill="#277FAF"
      />
    </svg>
    <h5>
      {{ localStorage.translations.pages['setting-users']['dialog-add']['priglashenie-v-proapp'] }}
    </h5>
    <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="registerUser">
      <div class="container_form invite d-grid gap-5">
        <BaseInput
          :label="
            localStorage.translations.pages['setting-users']['dialog-add-labels'][
              'elektronnaya-pochta'
            ]
          "
          v-model="email"
          prepend-inner-icon="alternate_email"
          :rules="['required', 'email']"
        />
        <BaseInput
          :label="localStorage.translations.pages['setting-users']['dialog-add-labels']['imya']"
          v-model="first_name"
          :rules="['required']"
          prepend-inner-icon="far fa-user-circle"
        />
        <BaseInput
          :label="localStorage.translations.pages['setting-users']['dialog-add-labels']['familiya']"
          v-model="last_name"
          :rules="['required']"
          prepend-inner-icon="far fa-user-circle"
        />
        <BaseInput
          :label="localStorage.translations.pages.common.text.mail_language"
          v-model="language_id"
          :rules="['required']"
          type="select-language"
        />
        <div class="container_btn">
          <BaseButton
            :text="
              localStorage.translations.pages['setting-users']['dialog-add-buttons'][
                'otpravit-priglashenie'
              ]
            "
            type="submit"
          >
            <template v-slot:icon>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.57103 6.06429C1.49753 6.00654 1.4631 5.92022 1.4631 5.83329H1.45842V3.84937L0.606174 4.55929C0.4061 4.72612 0.291748 4.97112 0.291748 5.23129V13.125C0.291748 13.2772 0.334322 13.4178 0.402572 13.5426L5.281 9.72589L5.78032 9.33564L1.57103 6.06429Z"
                  fill="#F2F2F2"
                />
                <path
                  d="M13.3941 4.55929L12.5419 3.84937V5.83329H12.5372C12.5372 5.92022 12.5034 6.00654 12.4293 6.06372L8.22168 9.33389L9.30143 10.1721L13.6111 13.5181C13.6712 13.3991 13.7085 13.2673 13.7085 13.125V5.23129C13.7085 4.97114 13.5942 4.72614 13.3941 4.55929Z"
                  fill="#F2F2F2"
                />
                <path
                  d="M7.47705 9.4949C7.19298 9.27908 6.8068 9.27908 6.52038 9.49665L0.845703 13.937C0.944879 13.9767 1.0528 14 1.16655 14H12.8332C12.9581 14 13.0765 13.9726 13.1838 13.9253L7.47705 9.4949Z"
                  fill="#F2F2F2"
                />
                <path
                  d="M2.04175 0V5.691L6.26332 8.97168C6.7195 8.6806 7.28357 8.6806 7.7374 8.97168L11.9584 5.691V0H2.04175ZM8.75007 4.66668H7.29175V6.125C7.29175 6.286 7.16107 6.41668 7.00007 6.41668C6.83907 6.41668 6.7084 6.286 6.7084 6.125V4.66668H5.25007C5.08907 4.66668 4.9584 4.536 4.9584 4.375C4.9584 4.214 5.08907 4.08332 5.25007 4.08332H6.7084V2.625C6.7084 2.464 6.83907 2.33332 7.00007 2.33332C7.16107 2.33332 7.29175 2.464 7.29175 2.625V4.08332H8.75007C8.91107 4.08332 9.04175 4.214 9.04175 4.375C9.04175 4.536 8.91107 4.66668 8.75007 4.66668Z"
                  fill="#F2F2F2"
                />
              </svg>
            </template>
          </BaseButton>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'UserInviteModalForm',
  components: { CloseModalBtn },
  props: { onDownloadPageData: Function, closeModal: Function, subscriber: Boolean },
  data() {
    return {
      valid: false,
      email: '',
      first_name: '',
      last_name: '',
      language_id: null,
    }
  },
  created() {
    if (this.$cookies.get('languageSelect')) {
      this.language_id = this.$cookies.get('languageSelect').id
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    async registerUser() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          language_id: this.language_id,
        }
        if (this.subscriber) {
          data.type = 'subscriber'
        }
        this.$store
          .dispatch('auth/register', data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications.invitation_is_sent,
                  IsError: false,
                },
                { root: true },
              )
              this.closeModal()
              this.onDownloadPageData()
            }
          })
          .catch((err) => {
            this.email = ''
            this.first_name = ''
            this.last_name = ''
            console.log(err)
            if (err.response.data.email) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: err.response.data.email[0],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contacts {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  position: relative;

  svg.icon {
    margin: 60px 0px 33.75px 0px;
  }
  h5 {
    font-weight: 500;
    font-size: 36px;
    line-height: 42px;
    text-align: center;
    margin-bottom: 50px;
  }
  .container_btn {
    text-align: center;
    padding-top: 15px;
    .v-input__append-inner i {
      color: black !important;
    }
    .v-btn {
      border-radius: 28px;
    }
  }
}
.v-text-field {
  input {
    padding: 12px 0px 12px 16px !important;
  }
}

.container_form {
  text-align: left;
  padding: 0px 100px 80px 100px;
  label {
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    color: #52525f;
  }
  :deep() .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
    fieldset {
      border: 1px solid #b4b4b4;
      border-radius: 4px;
    }
    .theme--light.v-icon {
      color: #b4b4b4;
    }
  }
  .save_contact {
    width: 170px;
    background: #277faf;
    border-radius: 8px;
    color: white !important;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    &:hover {
      background-color: #16558f;
    }
  }
}
.container_btn {
  display: flex;
  justify-content: center;
}
</style>
